export const appConfig = {
  CustomerServicePhone: '4006565013', // 客服电话
  // PromotionTargetPath: '/reportQuery', // 推广生成链接的目标路径
  PromotionTargetPath: '/bgQuery', // 推广生成链接的目标路径
  ReportMaterialApply: 'ReportMaterialApply', // 报告申请物料页面的标识
  WechatService: 'https://work.weixin.qq.com/kfid/kfc5716e6d3410709a4', // 微信客服
  WechatPhoneService: 'https://work.weixin.qq.com/kfid/kfcd85644f01da639c8', // 广告电话客服
} as const;
